<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Panel de control',
            icon: 'fas fa-home text-primary',
            path: '/dashboard',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$can('index', 'visits')"
          :link="{
            name: 'Visitas',
            icon: 'fas fa-calendar-alt text-green',
            path: '/visits',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$can('index', 'projections')"
          :link="{
            name: 'Proyecciones',
            icon: 'fas fa-chart-line text-black',
            path: '/projections',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$can('index', 'orders')"
          :link="{
            name: 'Pedidos',
            icon: 'fas fa-box-open text-yellow',
            path: '/orders',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$can('index', 'delivery_notes')"
          :link="{
            name: 'Remitos',
            icon: 'fas fa-file-invoice text-black',
            path: '/delivery-notes',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$can('index', 'quotations')"
          :link="{
            name: 'Cotizaciones',
            icon: 'fas fa-file-invoice text-purple',
            path: '/quotations',
          }"
        >
        </sidebar-item>

        <sidebar-item :link="{ name: 'Pagos', icon: 'fas fa-file-invoice-dollar text-brown' }" cy-id="sidebar-payments">
          <sidebar-item
            v-if="$can('see_receipts', 'payment_access')"
            :link="{
              name: 'Recibos',
              path: '/receipts',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="$can('see_orders_to_cancel', 'payment_access')"
            :link="{
              name: 'Pedidos a Cancelar',
              path: '/receipts/accepted-orders',
            }"
          >
          </sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Liquidaciones', icon: 'fas fa-handshake' }" cy-id="sidebar-payments">
          <sidebar-item
            v-if="$can('see_orders_to_be_settled', 'payment_access')"
            :link="{
              name: 'Pedidos a Liquidar',
              path: '/receipts/liquidation-orders',
            }"
          >
          </sidebar-item>

          <sidebar-item
            v-if="$can('see_advisor_settlements', 'payment_access')"
            :link="{
              name: 'Liquidaciones Asesores',
              path: '/receipts/liquidation-by-seller',
            }"
            cy-id="sidebar-seller-to-liquidate"
          >
          </sidebar-item>

          <sidebar-item
            v-if="$can('see_advisor_settlements_to_be_invoiced', 'payment_access')"
            :link="{
              name: 'Liquidaciones Asesores a Facturar',
              path: '/receipts/liquidation-by-seller-liquidated',
            }"
            cy-id="sidebar-seller-liquidated"
          >
          </sidebar-item>

          <sidebar-item
            v-if="$can('see_distributor_settlements', 'payment_access')"
            :link="{
              name: 'Liquidaciones Distribuidores',
              path: '/receipts/liquidation-by-distributor',
            }"
            cy-id="sidebar-distributor-to-liquidate"
          >
          </sidebar-item>

          <sidebar-item
            v-if="$can('see_distributor_settlements_to_be_invoiced', 'payment_access')"
            :link="{
              name: 'Liquidaciones Distribuidores a Facturar',
              path: '/receipts/liquidation-by-distributor-liquidated',
            }"
            cy-id="sidebar-distributor-liquidated"
          >
          </sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="canSeeAdministratorMenu"
          :link="{ name: 'Administrador', icon: 'fas fa-user-cog text-orange' }"
        >
          <sidebar-item v-if="$can('index', 'sellers')" :link="{ name: 'Asesores Técnicos', path: '/sellers' }" />

          <sidebar-item
            v-if="$can('index', 'distributors')"
            :link="{ name: 'Distribuidores', path: '/distributors' }"
          />

          <sidebar-item v-if="$can('index', 'producers')" :link="{ name: 'Productores', path: '/producers' }" />

          <sidebar-item v-if="$can('index', 'fields')" :link="{ name: 'Campos', path: '/fields' }" />

          <sidebar-item v-if="$can('index', 'plots')" :link="{ name: 'Lotes', path: '/plots' }" />
        </sidebar-item>

        <sidebar-item v-if="canSeeDocumentsMenu" :link="{ name: 'Documentos', icon: 'fas fa-file-alt text-default' }">
          <sidebar-item v-if="$can('index', 'documents')" :link="{ name: 'Todos', path: '/documents' }" />

          <sidebar-item
            v-if="$can('index', 'documents')"
            :link="{ name: 'Cuenta Corriente', path: $router.resolve({ name: 'AccountDocuments' }).href }"
          />

          <sidebar-item
            v-if="$can('index', 'documents')"
            :link="{ name: 'Stock', path: $router.resolve({ name: 'StockDocuments' }).href }"
          />

          <sidebar-item
            v-if="$can('index', 'documents')"
            :link="{ name: 'Liquidación', path: $router.resolve({ name: 'SettlementDocuments' }).href }"
          />
        </sidebar-item>

        <sidebar-item v-if="canSeeConfigurationMenu" :link="{ name: 'Configuración', icon: 'fas fa-cog text-info' }">
          <sidebar-item v-if="$can('index', 'campaigns')" :link="{ name: 'Campañas', path: '/campaigns' }" />

          <sidebar-item v-if="$can('index', 'crops')" :link="{ name: 'Cultivos', path: '/crops' }" />

          <sidebar-item v-if="$can('index', 'articles')" :link="{ name: 'Artículos', path: '/articles' }" />

          <sidebar-item v-if="$can('index', 'varieties')" :link="{ name: 'Variedades', path: '/varieties' }" />

          <sidebar-item v-if="$can('index', 'roles')" :link="{ name: 'Roles', path: '/roles' }" />

          <sidebar-item v-if="$can('index', 'users')" :link="{ name: 'Usuarios', path: '/users' }" />

          <sidebar-item
            v-if="$can('index', 'dollar_quotations')"
            :link="{ name: 'Cotización Dólar', path: '/dollar-quotations' }"
          />
          <sidebar-item
            v-if="$can('index', 'concept_payment_types')"
            :link="{ name: 'Tipos de concepto de pago', path: '/concept-payment-types' }"
          />
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" mode="out-in" origin="center top">
          <!-- your content here -->
          <router-view :key="$route.fullPath"></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import { FadeTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },

  computed: {
    canSeeAdministratorMenu() {
      return (
        this.$can('index', 'distributors') ||
        this.$can('index', 'sellers') ||
        this.$can('index', 'producers') ||
        this.$can('index', 'fields') ||
        this.$can('index', 'plots')
      );
    },

    canSeeDocumentsMenu() {
      return this.$can('index', 'documents');
    },

    canSeeConfigurationMenu() {
      return (
        this.$can('index', 'campaigns') ||
        this.$can('index', 'crops') ||
        this.$can('index', 'varieties') ||
        this.$can('index', 'roles') ||
        this.$can('index', 'users') ||
        this.$can('index', 'dollar_quotations')
      );
    },
  },

  mounted() {
    this.initScrollbar();
  },

  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('scrollbar-inner');
      }
    },
  },
};
</script>

<style lang="scss">
.main-content {
  min-height: 100vh;
  padding-bottom: 100px;
}
</style>
